import { useCola, useEnLinea } from './hooks';

/**
 * Una sola línea que dice si algo está esperando a subir.
 *
 * Es la pieza que convierte "he hecho la foto y no sé si se ha guardado" en
 * "está en cola, tranquilo". Sin ella, trabajar sin cobertura da la sensación
 * de estar perdiendo el trabajo, aunque no se pierda nada.
 */
export function BarraEstado({ alAbrirPendientes }: { alAbrirPendientes: () => void }) {
  const enLinea = useEnLinea();
  const cola = useCola();

  // Lo primero es lo que el usuario puede arreglar.
  if (cola.pausadaPorClave) {
    return (
      <div className="barra-estado fallo">
        Reconecta tu cuenta de Gextia para que suba lo pendiente.
      </div>
    );
  }

  if (cola.conError > 0) {
    return (
      <div className="barra-estado fallo">
        {cola.conError === 1
          ? '1 cosa no se pudo guardar.'
          : `${cola.conError} cosas no se pudieron guardar.`}
        <button type="button" onClick={alAbrirPendientes}>
          Ver
        </button>
      </div>
    );
  }

  if (!enLinea) {
    return (
      <div className="barra-estado sin-red">
        Sin conexión.{' '}
        {cola.pendientes > 0
          ? `${cola.pendientes} ${cola.pendientes === 1 ? 'cosa' : 'cosas'} en cola, subirán solas.`
          : 'Puedes seguir trabajando.'}
        {cola.pendientes > 0 && (
          <button type="button" onClick={alAbrirPendientes}>
            Ver
          </button>
        )}
      </div>
    );
  }

  if (cola.pendientes > 0) {
    return (
      <div className="barra-estado">
        Subiendo {cola.pendientes} {cola.pendientes === 1 ? 'elemento' : 'elementos'}…
        <button type="button" onClick={alAbrirPendientes}>
          Ver
        </button>
      </div>
    );
  }

  return null;
}
